<template>
    <div>
        <form id="frmNavigate" :action="navigateAction" method="post">
            <input :value="$store.requestParams.securityToken" name="securityToken" type="hidden" />
        </form>
        <form id="frmRedirect" :action="redirectAction" :target="redirectTarget" method="post">
            <input id="userid" :value="userId" type="hidden" name="userid" />
            <input id="token" :value="token" type="hidden" name="token" />
            <input
                v-if="$store.user && $store.user.impersonator"
                :value="$store.user.impersonator.userId"
                type="hidden"
                name="impersonatorUserId"
            />
            <input
                v-if="$store.user && $store.user.userId === userId && $store.user.orgId !== $store.user.ownerId"
                id="orgId"
                :value="$store.user.orgId"
                type="hidden"
                name="orgId"
            />
            <input id="lang" :value="$store.requestParams.lang?.replace('_', '-')" type="hidden" name="lang" />
            <input :value="$t('Centrex')" type="hidden" name="branding_Centrex" />
            <input :value="$t('CENTREX_SHORT')" type="hidden" name="branding_Centrex_short" />
            <input :value="$t('Contact')" type="hidden" name="branding_Contact" />
            <input :value="$t('View')" type="hidden" name="branding_View" />
            <input :value="$t('Response')" type="hidden" name="branding_Response" />
            <input :value="$t('Recorder')" type="hidden" name="branding_Recorder" />
            <input :value="$t('COMPANY')" type="hidden" name="branding_COMPANY" />
        </form>
        <form
            v-if="exportOptions"
            id="app_export"
            :action="apiUrl + exportOptions.link"
            target="app_export_frame"
            method="post"
        >
            <input :value="$store.securityToken" name="securityToken" type="hidden" />
            <input v-if="$store.requestParams.lang" :value="$store.requestParams.lang" name="lang" type="hidden" />
            <input v-for="(value, name) in exportOptions.params" :name="name" :value="value" type="hidden" />
        </form>
        <iframe id="app_export_frame" name="app_export_frame" style="display: none"> </iframe>
    </div>
</template>

<script>
    import { load } from '@/utils/Http';

    export default {
        name: 'Navigate',
        props: {
            navigateOptions: {
                type: Object,
                default: () => null,
            },
            exportOptions: {
                type: Object,
                default: () => null,
            },
        },
        data() {
            return {
                // eslint-disable-next-line no-undef
                apiUrl: process.env.APP_API_PATH,
                navigateAction: null,
                redirectAction: null,
                redirectTarget: '',
                token: null,
                userId: null,
                windows: {},
            };
        },
        watch: {
            navigateOptions(val) {
                if (val) {
                    this.navigate(val);
                }
            },
            exportOptions(val) {
                if (val) {
                    this.$nextTick(() => {
                        document.getElementById('app_export').submit();
                        this.$store.exportFile(null);
                    });
                }
            },
        },
        methods: {
            navigate(option) {
                this.$store.darkMode = false;
                this.$store.switchMode = false;
                if (option.externalLink) {
                    // Focus the product window if it has already been opened
                    if (
                        option.target === 1 &&
                        this.windows[option.name] !== undefined &&
                        this.windows[option.name].closed === false
                    ) {
                        this.windows[option.name].focus();
                        return;
                    }

                    load('serviceportal/tokencode', { product: option.name }, (response) => {
                        this.token = response.token;
                        this.userId = response.userID;
                        this.redirectTarget = '';
                        this.redirectAction = response.link.replace('{server.name}', window.location.host);

                        if (option.target === 1) {
                            this.windows[option.name] = window.open(
                                '',
                                'Win' + option.name,
                                'location=1, menubar=1, resizable=1, scrollbars=1, status=1, toolbar=1',
                            );
                            if (window.self.name === 'Win' + option.name) {
                                this.redirectTarget = '_blank';
                            } else {
                                this.redirectTarget = 'Win' + option.name;
                            }

                            this.$nextTick(() => {
                                document.getElementById('frmRedirect').submit();
                            });

                            this.windows[option.name].focus();
                        } else if (option.target === 3) {
                            this.windows[option.name] = window.open(
                                this.redirectAction,
                                'Win' + option.name,
                                'location=1, menubar=1, resizable=1, scrollbars=1, status=1, toolbar=1',
                            );
                            this.windows[option.name].focus();
                        } else {
                            this.$nextTick(() => {
                                document.getElementById('frmRedirect').submit();
                            });
                        }
                    });
                } else if (option.link.substring(0, 1) === '/') {
                    this.$store.setMenuOption(option.name ?? null);
                    this.$router.push(option.link);
                } else if (option.route) {
                    this.$store.setMenuOption(option.route);
                    if (this.$route.path === '/custom') {
                        this.$nextTick(() => {
                            document.getElementById('frmLoadPage').submit();
                        });
                    } else {
                        this.$router.push('/custom');
                    }
                } else {
                    this.navigateAction = option.link;
                    this.$nextTick(() => {
                        document.getElementById('frmNavigate').submit();
                        this.$store.navigate(null);
                    });
                }
            },
        },
    };
</script>
